import React, { useContext, useState, useRef, useEffect } from 'react'
import { GET_FLAG_URL } from '../../constants'
import AppContext from '../context/app'
import useGetAllCountry from '../hooks/useGetAllCountry'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'
import { useTheme } from '@emotion/react'
import classNames from 'classnames'

export default function CountrySelector({ className, style }) {
    const maxHeight = 300
    const theme = useTheme()
    const allCountry = useGetAllCountry()
    const { country } = useContext(AppContext)

    const inputRef = useRef(null)
    const [show, setShow] = useState(false)
    const [userInput, setUserInput] = useState('')

    function changeCountry(country) {
        const event = new CustomEvent("COUNTRY_CURRENCY_CHANGED", { detail: country })
        if (typeof window !== 'undefined') window.dispatchEvent(event)
    }

    const toggle = (e) => {
        setShow(!show)
    }

    useEffect(() => {
        if (show) inputRef.current.focus()
        else setUserInput('')
    }, [show])

    return (
        <DropdownButton
            id='dropdown-country-selector'
            title={country?.name || 'COUNTRY'}
            variant='dark'
            menuVariant='dark'
            style={style}
            className={className}
            css={{
                '& button': {
                    textTransform: 'uppercase',
                    '&.dropdown-item:hover': {
                        background: theme.colors.primary,
                    },
                }, 
                '& > button': {
                    '&::before': {
                        display: 'block',
                        content: "''",
                        background: `url(${GET_FLAG_URL(country?.countryIso)}) center / cover no-repeat`,
                        height: 16,
                        width: 32,
                        marginRight: 8,
                    }
                },               
            }}
        >
            <input
                ref={inputRef}
                placeholder='Filter countries'
                name='country-filter'
                className='placeholder-font-family-primary w-100 mb-3'
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onMouseEnter={() => inputRef.current.focus()}
                style={{ fontSize: 22 }}
            />
            
            <div
                style={{ maxHeight }}
                className='overflow-y-auto overflow-x-hidden'
            >
                {allCountry
                    .filter(({ name }) => name.toLowerCase().includes(userInput.toLowerCase()))
                    .map(c => {
                        const { id, name, countryIso } = c
                        const isActive = countryIso === country?.countryIso
    
                        return (
                            <Dropdown.Item
                                key={id}
                                as={Button}
                                onClick={() => changeCountry(c)}
                                title={name}
                                active={isActive}
                            >
                                <Stack direction='horizontal' className='align-items-center' gap={3}>
                                    <img src={GET_FLAG_URL(countryIso)} alt='' width={32} loading='lazy' />
                                    <span style={{ fontSize: 18 }} className='text-uppercase'>{name}</span>
                                </Stack>
                            </Dropdown.Item>
                        )
                    })}
            </div>                    
        </DropdownButton>
    )
}